module.exports = __webpack_public_path__ + "static/media/logo-transparent.faeef931.svg";